import { SITE_COPY } from "./siteCopy";

export const LANGUAGES = [
    { code: "rom", label: "ROM", htmlLang: "ro-MD", ogLocale: "ro_MD" },
    { code: "rus", label: "RUS", htmlLang: "ru-MD", ogLocale: "ru_MD" },
    { code: "eng", label: "ENG", htmlLang: "en-MD", ogLocale: "en_US" },
];

export const DEFAULT_LANGUAGE = "rom";

export const translations = {
    rom: {
        site: {
            name: "Femei de succes din Republica Moldova",
            logo: "Femei de succes",
            logoSubtitle: "din Republica Moldova",
            publicSources: "Informații din surse publice.",
        },
        nav: {
            home: "Home",
            news: "Noutăți",
            about: "Despre noi",
            contact: "Contacte",
            privacy: "Confidențialitate",
            terms: "Termeni",
        },
        hero: {
            title: "Descoperă poveștile care inspiră",
            cta: "Explorează",
        },
        home: {
            remarkable: "Femei Remarcabile",
            recognize: "Recunoști femeia?",
            successful: "Femei de succes",
            noResults: "Nu s-au găsit rezultate",
            loading: "Se încarcă...",
            monthlyTitle: "Femeia lunii",
            discoverWomen: "Descoperă femeile din Republica Moldova",
        },
        news: {
            title: "Noutăți",
            intro: "Noutăți și actualizări despre femei remarcabile, proiecte, evenimente și apariții publice relevante.",
            allNews: "Vezi toate noutățile",
            latest: "Ultimele noutăți",
            readMore: "Citeste mai mult",
            source: "Sursa",
            loading: "Se încarcă noutățile...",
            empty: "Nu sunt noutăți publicate momentan.",
            notFound: "Noutatea nu a fost găsită",
            seoDescription:
                "Citește noutăți și actualizări despre femei remarcabile din Republica Moldova, proiecte, evenimente și povești publice relevante.",
        },
        filters: {
            title: "Filtrează",
            name: "Nume / Prenume",
            namePlaceholder: "Caută după nume sau prenume...",
            category: "Categorie",
            categoriesPlaceholder: "Selectează categorii",
            place: "Locul realizării",
            placesPlaceholder: "Selectează locuri",
            selected: "{{count}} selectate",
            apply: "Aplică filtre",
            reset: "Resetează",
        },
        minigame: {
            loading: "Se încarcă...",
            score: "Scorul tău:",
            wins: "câștiguri",
            submitted: "Acest scor a fost deja trimis",
            sendError: "Eroare la trimitere",
            banned: "Nu mai poți trimite scoruri",
            namePlaceholder: "Introdu numele tău",
            submit: "Trimite",
        },
        profile: {
            home: "Acasă",
            mainAchievement: "Realizare principală",
            place: "Locul realizării:",
            about: "Despre",
            related: "Din aceeași categorie",
            otherWomen: "Alte femei remarcabile",
            recognize: "Recunoști femeia?",
            loading: "Se încarcă...",
            noRelated: "Nu sunt alte profiluri disponibile în această categorie.",
            noRandom: "Nu sunt profiluri disponibile momentan.",
            notFound: "Persoana nu a fost găsită",
            backHome: "← Înapoi la pagina principală",
            notFoundSeoTitle: "Profil negăsit",
            notFoundSeoDescription:
                "Profilul solicitat nu a fost găsit în baza de date Femei de succes din Republica Moldova. Revino la pagina principală pentru alte profiluri.",
        },
        contact: {
            title: "Contactează-ne",
            intro: "Ai o întrebare, o sugestie sau dorești să soliciți modificarea ori eliminarea unui profil? Scrie-ne folosind formularul de mai jos sau direct la adresa de email.",
            infoTitle: "Informații de contact",
            phone: "Telefon",
            email: "Email",
            country: "Țara",
            countryValue: "Republica Moldova",
            note: "Răspundem, de regulă, în 1-3 zile lucrătoare. Pentru cereri privind datele personale sau eliminarea unui profil, consultă și",
            formTitle: "Formular de contact",
            name: "Nume",
            namePlaceholder: "Numele dvs.",
            subject: "Subiect",
            subjectPlaceholder: "Ex: Solicitare eliminare profil",
            message: "Mesaj",
            messagePlaceholder: "Scrieți mesajul dvs. aici...",
            requiredError: "Completați toate câmpurile obligatorii.",
            sendError: "Eroare la trimitere. Încercați din nou.",
            sending: "Se trimite...",
            submit: "Trimite mesajul",
        },
        about: {
            title: "Despre noi",
            sections: [
                {
                    title: "Misiunea noastră",
                    paragraphs: [
                        "Femei de succes din Republica Moldova este o platformă dedicată recunoașterii și promovării femeilor remarcabile originare din Republica Moldova care și-au lăsat amprenta în știință, cultură, sport, afaceri, politică, artă și alte domenii.",
                        "Credem că poveștile acestor femei merită să fie cunoscute, celebrate și transmise generațiilor viitoare.",
                    ],
                },
                {
                    title: "Ce oferim",
                    paragraphs: [
                        "Baza noastră de date cuprinde profiluri ale femeilor din Republica Moldova care s-au remarcat în țară și pe plan internațional.",
                        "Platforma include și un joc interactiv de recunoaștere prin care utilizatorii pot testa cât de bine cunosc femeile de succes din Republica Moldova.",
                    ],
                    list: [
                        "Informații biografice și domeniu de activitate",
                        "Descrierea realizărilor și contribuțiilor",
                        "Locul unde și-au desfășurat activitatea principală",
                        "Fotografie de profil",
                    ],
                },
                {
                    title: "Datele noastre",
                    paragraphs: [
                        "Toate informațiile publicate pe această platformă sunt colectate din surse publice disponibile online și sunt prezentate cu scopul de a promova personalitățile feminine moldovene.",
                        "Dacă doriți modificarea sau eliminarea unui profil, ne puteți contacta prin pagina de contact.",
                    ],
                },
            ],
        },
        legal: {
            privacyTitle: "Politica de Confidențialitate",
            privacyUpdated: "Ultima actualizare: 25 iunie 2026",
            termsTitle: "Termeni și Condiții",
            termsUpdated: "Data intrării în vigoare: 25 iunie 2026",
            privacySections: [
                {
                    title: "1. Introducere",
                    paragraphs: [
                        "Această Politică de Confidențialitate explică ce date colectează site-ul Femei de succes din Republica Moldova, cum sunt folosite aceste date și ce drepturi aveți în legătură cu datele personale.",
                    ],
                },
                {
                    title: "2. Date pe care le colectăm direct",
                    paragraphs: [
                        "Colectăm direct datele trimise prin formularul de contact: nume, e-mail, subiect, mesaj și adresa IP asociată trimiterii.",
                        "Salvăm în localStorage preferința de cookie-uri, scorul minigame-ului și statusul de restricționare a jocului.",
                        "Nu colectăm direct durata sesiunii sau istoricul complet de navigare. Profilurile publicate sunt alcătuite din informații disponibile public.",
                    ],
                },
                {
                    title: "3. Cum folosim datele",
                    list: [
                        "pentru operarea și securizarea site-ului;",
                        "pentru răspunsul la mesajele trimise de utilizatori;",
                        "pentru memorarea preferinței privind cookie-urile;",
                        "pentru funcționarea minigame-ului;",
                        "pentru afișarea reclamelor prin Google AdSense.",
                    ],
                },
                {
                    title: "4. Google AdSense și reclame personalizate",
                    paragraphs: [
                        "Site-ul folosește Google AdSense pentru afișarea de reclame. Google și alți furnizori terți pot utiliza cookie-uri pentru a difuza reclame pe baza vizitelor anterioare pe acest site sau pe alte site-uri.",
                        "Google AdSense poate folosi cookie-uri pentru reclame personalizate. Mai multe informații sunt disponibile la https://policies.google.com/technologies/ads.",
                    ],
                },
                {
                    title: "5. Google Analytics",
                    paragraphs: [
                        "În codul actual al site-ului nu este configurat un identificator Google Analytics. Dacă Google Analytics va fi activat ulterior, politica va fi actualizată.",
                    ],
                },
                {
                    title: "6. Drepturile utilizatorilor",
                    list: [
                        "dreptul de acces la datele personale;",
                        "dreptul la rectificare;",
                        "dreptul la ștergere;",
                        "dreptul la restricționarea prelucrării;",
                        "dreptul de opoziție;",
                        "dreptul de a retrage consimțământul.",
                    ],
                },
                {
                    title: "7. Date de contact",
                    paragraphs: [
                        "Pentru cereri privind datele personale, cookie-urile sau profilurile publicate, ne puteți contacta la ellemoldova1@gmail.com sau la +373 68 680 112.",
                    ],
                },
            ],
            termsSections: [
                {
                    title: "1. Acceptarea termenilor",
                    paragraphs: [
                        "Prin accesarea și utilizarea site-ului Femei de succes din Republica Moldova, acceptați acești Termeni și Condiții.",
                    ],
                },
                {
                    title: "2. Scopul și descrierea site-ului",
                    paragraphs: [
                        "Site-ul este o platformă informativă dedicată prezentării femeilor originare din Republica Moldova sau asociate cu Republica Moldova, care s-au remarcat în diverse domenii.",
                        "Informațiile publicate sunt colectate, sintetizate și organizate din surse publice.",
                    ],
                },
                {
                    title: "3. Utilizarea conținutului",
                    paragraphs: [
                        "Nu pretindem că deținem drepturile de autor asupra fotografiilor, citatelor, textelor sau altor materiale preluate din surse publice ori aparținând titularilor lor originali.",
                        "Conținutul publicat pe site poate fi preluat, distribuit sau reutilizat liber, cu responsabilitatea utilizatorului de a respecta drepturile titularilor originali.",
                    ],
                },
                {
                    title: "4. Responsabilități și limitări",
                    paragraphs: [
                        "Depunem eforturi pentru ca informațiile publicate să fie corecte și utile, dar nu garantăm că toate datele sunt complete, actualizate sau lipsite de erori.",
                        "Site-ul este furnizat în scop informativ și nu ne asumăm responsabilitatea pentru decizii luate exclusiv pe baza conținutului publicat.",
                    ],
                },
                {
                    title: "5. Modificarea sau eliminarea unui profil",
                    paragraphs: [
                        "Persoanele vizate, reprezentanții acestora sau titularii de drepturi pot solicita modificarea, completarea, corectarea sau eliminarea unui profil.",
                        "Solicitările pot fi trimise prin pagina de contact, la ellemoldova1@gmail.com sau la +373 68 680 112.",
                    ],
                },
                {
                    title: "6. Legea aplicabilă",
                    paragraphs: ["Acești Termeni și Condiții sunt guvernați de legislația Republicii Moldova."],
                },
            ],
        },
        cookie: {
            title: "Politica de Cookie-uri",
            text: "Acest site utilizează cookie-uri și tehnologii similare pentru memorarea preferinței dvs. și pentru afișarea reclamelor Google AdSense, inclusiv reclame personalizate acolo unde este permis.",
            privacy: "Politica de Confidențialitate",
            reject: "Respinge",
            accept: "Acceptă",
        },
        seo: {
            defaultDescription:
                "Descoperă femei remarcabile din Republica Moldova, profiluri, realizări și povești de succes din cultură, sport, știință, afaceri și artă, în diaspora.",
            defaultTitle: "Femei de succes din Republica Moldova — Femei remarcabile și povești care inspiră",
            profileFallbackTitle: "Profil femeie de succes",
            profileFallbackDescription:
                "Descoperă profilul unei femei remarcabile din Republica Moldova, cu realizări, domeniu de activitate, fotografie și poveste de succes din surse publice.",
            publicInfo: "Profil alcătuit din informații disponibile public.",
            womanIncluded: "{{name}} este inclusă în proiectul Femei de succes din Republica Moldova",
            discoverStory: "Descoperă povestea ei de succes pe {{siteName}}.",
        },
    },
    rus: {
        site: {
            name: "Femei de succes din Republica Moldova",
            logo: "Femei de succes",
            logoSubtitle: "din Republica Moldova",
            publicSources: "Информация из открытых источников.",
        },
        nav: {
            home: "Главная",
            news: "Обновления",
            about: "О проекте",
            contact: "Контакты",
            privacy: "Конфиденциальность",
            terms: "Условия",
        },
        hero: {
            title: "Откройте истории, которые вдохновляют",
            cta: "Смотреть",
        },
        home: {
            remarkable: "Выдающиеся женщины",
            recognize: "Узнаете женщину?",
            successful: "Успешные женщины",
            noResults: "Результаты не найдены",
            loading: "Загрузка...",
            monthlyTitle: "Женщина месяца",
            discoverWomen: "Откройте для себя женщин Республики Молдова",
        },
        news: {
            title: "Обновления",
            intro: "Обновления о выдающихся женщинах, проектах, событиях и публичных историях.",
            allNews: "Все обновления",
            latest: "Последние новости",
            readMore: "Читать дальше",
            source: "Источник",
            loading: "Загрузка обновлений...",
            empty: "Пока нет опубликованных обновлений.",
            notFound: "Обновление не найдено",
            seoDescription:
                "Читайте обновления о выдающихся женщинах из Республики Молдова, проектах, событиях и публичных историях.",
        },
        filters: {
            title: "Фильтр",
            name: "Имя / Фамилия",
            namePlaceholder: "Искать по имени или фамилии...",
            category: "Категория",
            categoriesPlaceholder: "Выберите категории",
            place: "Место достижения",
            placesPlaceholder: "Выберите места",
            selected: "Выбрано: {{count}}",
            apply: "Применить фильтры",
            reset: "Сбросить",
        },
        minigame: {
            loading: "Загрузка...",
            score: "Ваш счет:",
            wins: "побед",
            submitted: "Этот счет уже был отправлен",
            sendError: "Ошибка отправки",
            banned: "Вы больше не можете отправлять результаты",
            namePlaceholder: "Введите ваше имя",
            submit: "Отправить",
        },
        profile: {
            home: "Главная",
            mainAchievement: "Главное достижение",
            place: "Место достижения:",
            about: "О ней",
            related: "Из той же категории",
            otherWomen: "Другие выдающиеся женщины",
            recognize: "Узнаете женщину?",
            loading: "Загрузка...",
            noRelated: "В этой категории пока нет других профилей.",
            noRandom: "Профили временно недоступны.",
            notFound: "Профиль не найден",
            backHome: "← Вернуться на главную",
            notFoundSeoTitle: "Профиль не найден",
            notFoundSeoDescription:
                "Запрошенный профиль не найден в базе данных проекта. Вернитесь на главную страницу, чтобы посмотреть другие профили.",
        },
        contact: {
            title: "Свяжитесь с нами",
            intro: "Есть вопрос, предложение или запрос на изменение либо удаление профиля? Напишите нам через форму ниже или напрямую на email.",
            infoTitle: "Контактная информация",
            phone: "Телефон",
            email: "Email",
            country: "Страна",
            countryValue: "Республика Молдова",
            note: "Обычно мы отвечаем в течение 1-3 рабочих дней. По вопросам персональных данных или удаления профиля смотрите также",
            formTitle: "Форма обратной связи",
            name: "Имя",
            namePlaceholder: "Ваше имя",
            subject: "Тема",
            subjectPlaceholder: "Например: запрос на удаление профиля",
            message: "Сообщение",
            messagePlaceholder: "Напишите ваше сообщение здесь...",
            requiredError: "Заполните все обязательные поля.",
            sendError: "Ошибка отправки. Попробуйте еще раз.",
            sending: "Отправка...",
            submit: "Отправить сообщение",
        },
        about: {
            title: "О проекте",
            sections: [
                {
                    title: "Наша миссия",
                    paragraphs: [
                        "Femei de succes din Republica Moldova — это платформа, посвященная признанию и продвижению выдающихся женщин, связанных с Республикой Молдова.",
                        "Мы считаем, что эти истории должны быть известны, сохранены и переданы будущим поколениям.",
                    ],
                },
                {
                    title: "Что мы предлагаем",
                    paragraphs: [
                        "Наша база данных содержит профили женщин из Республики Молдова, добившихся заметных результатов в стране и за рубежом.",
                        "На платформе также есть интерактивная игра, где пользователи могут проверить, насколько хорошо они знают успешных женщин Молдовы.",
                    ],
                    list: [
                        "Биографическая информация и сфера деятельности",
                        "Описание достижений и вклада",
                        "Основное место деятельности",
                        "Профильная фотография",
                    ],
                },
                {
                    title: "Наши данные",
                    paragraphs: [
                        "Вся информация на платформе собрана из открытых онлайн-источников и представлена с целью продвижения женских личностей Молдовы.",
                        "Если вы хотите изменить или удалить профиль, свяжитесь с нами через страницу контактов.",
                    ],
                },
            ],
        },
        legal: {
            privacyTitle: "Политика конфиденциальности",
            privacyUpdated: "Последнее обновление: 25 июня 2026",
            termsTitle: "Условия использования",
            termsUpdated: "Дата вступления в силу: 25 июня 2026",
            privacySections: [
                {
                    title: "1. Введение",
                    paragraphs: [
                        "Эта Политика конфиденциальности объясняет, какие данные собирает сайт, как они используются и какие права есть у пользователей.",
                    ],
                },
                {
                    title: "2. Данные, которые мы собираем напрямую",
                    paragraphs: [
                        "Мы напрямую собираем данные, отправленные через контактную форму: имя, e-mail, тему, сообщение и IP-адрес отправки.",
                        "В localStorage сохраняются предпочтение по cookie, счет мини-игры и статус ограничения игры.",
                        "Мы не собираем напрямую длительность сессии или полную историю навигации. Профили составлены из открытых источников.",
                    ],
                },
                {
                    title: "3. Как мы используем данные",
                    list: [
                        "для работы и защиты сайта;",
                        "для ответа на сообщения пользователей;",
                        "для сохранения предпочтений по cookie;",
                        "для работы мини-игры;",
                        "для показа рекламы Google AdSense.",
                    ],
                },
                {
                    title: "4. Google AdSense и персонализированная реклама",
                    paragraphs: [
                        "Сайт использует Google AdSense для показа рекламы. Google и другие сторонние поставщики могут использовать cookie для показа рекламы на основе предыдущих посещений.",
                        "Google AdSense может использовать cookie для персонализированной рекламы. Подробнее: https://policies.google.com/technologies/ads.",
                    ],
                },
                {
                    title: "5. Google Analytics",
                    paragraphs: [
                        "В текущем коде сайта Google Analytics не настроен. Если он будет включен позже, политика будет обновлена.",
                    ],
                },
                {
                    title: "6. Права пользователей",
                    list: [
                        "право доступа к персональным данным;",
                        "право на исправление;",
                        "право на удаление;",
                        "право на ограничение обработки;",
                        "право на возражение;",
                        "право отозвать согласие.",
                    ],
                },
                {
                    title: "7. Контакты",
                    paragraphs: [
                        "По вопросам персональных данных, cookie или опубликованных профилей пишите на ellemoldova1@gmail.com или звоните +373 68 680 112.",
                    ],
                },
            ],
            termsSections: [
                {
                    title: "1. Принятие условий",
                    paragraphs: [
                        "Используя сайт Femei de succes din Republica Moldova, вы соглашаетесь с этими Условиями использования.",
                    ],
                },
                {
                    title: "2. Цель и описание сайта",
                    paragraphs: [
                        "Сайт является информационной платформой о женщинах, связанных с Республикой Молдова, которые добились заметных результатов в разных сферах.",
                        "Опубликованная информация собрана и структурирована из открытых источников.",
                    ],
                },
                {
                    title: "3. Использование контента",
                    paragraphs: [
                        "Мы не заявляем права собственности на фотографии, цитаты, тексты или другие материалы, взятые из открытых источников или принадлежащие их авторам.",
                        "Контент можно свободно распространять и использовать, при этом пользователь несет ответственность за соблюдение прав оригинальных правообладателей.",
                    ],
                },
                {
                    title: "4. Ответственность и ограничения",
                    paragraphs: [
                        "Мы стараемся публиковать точную и полезную информацию, но не гарантируем ее полноту, актуальность или отсутствие ошибок.",
                        "Сайт предоставляется в информационных целях.",
                    ],
                },
                {
                    title: "5. Изменение или удаление профиля",
                    paragraphs: [
                        "Лицо, указанное в профиле, его представитель или правообладатель может запросить изменение, исправление или удаление профиля.",
                        "Запросы можно отправлять через страницу контактов, на ellemoldova1@gmail.com или по телефону +373 68 680 112.",
                    ],
                },
                {
                    title: "6. Применимое право",
                    paragraphs: ["Эти условия регулируются законодательством Республики Молдова."],
                },
            ],
        },
        cookie: {
            title: "Политика cookie",
            text: "Этот сайт использует cookie и похожие технологии для сохранения ваших предпочтений и показа рекламы Google AdSense, включая персонализированную рекламу, где это разрешено.",
            privacy: "Политика конфиденциальности",
            reject: "Отклонить",
            accept: "Принять",
        },
        seo: {
            defaultDescription:
                "Откройте для себя выдающихся женщин Республики Молдова, их профили, достижения и истории успеха в культуре, спорте, науке, бизнесе и искусстве.",
            defaultTitle: "Femei de succes din Republica Moldova — выдающиеся истории, которые вдохновляют",
            profileFallbackTitle: "Профиль успешной женщины",
            profileFallbackDescription:
                "Откройте профиль выдающейся женщины из Республики Молдова: достижения, сфера деятельности, фотография и история из открытых источников.",
            publicInfo: "Профиль составлен из открытой информации.",
            womanIncluded: "{{name}} включена в проект Femei de succes din Republica Moldova",
            discoverStory: "Читайте ее историю успеха на сайте {{siteName}}.",
        },
    },
    eng: {
        site: {
            name: "Femei de succes din Republica Moldova",
            logo: "Femei de succes",
            logoSubtitle: "din Republica Moldova",
            publicSources: "Information from public sources.",
        },
        nav: {
            home: "Home",
            news: "Updates",
            about: "About",
            contact: "Contact",
            privacy: "Privacy",
            terms: "Terms",
        },
        hero: {
            title: "Discover stories that inspire",
            cta: "Explore",
        },
        home: {
            remarkable: "Remarkable Women",
            recognize: "Do you recognize her?",
            successful: "Successful Women",
            noResults: "No results found",
            loading: "Loading...",
            monthlyTitle: "Woman of the Month",
            discoverWomen: "Discover women from the Republic of Moldova",
        },
        news: {
            title: "Updates",
            intro: "Updates about remarkable women, projects, events, and relevant public stories.",
            allNews: "View all updates",
            latest: "Latest updates",
            readMore: "Read more",
            source: "Source",
            loading: "Loading updates...",
            empty: "No updates have been published yet.",
            notFound: "Update not found",
            seoDescription:
                "Read updates about remarkable women from the Republic of Moldova, projects, events, and relevant public stories.",
        },
        filters: {
            title: "Filter",
            name: "Name / Surname",
            namePlaceholder: "Search by name or surname...",
            category: "Category",
            categoriesPlaceholder: "Select categories",
            place: "Place of achievement",
            placesPlaceholder: "Select places",
            selected: "{{count}} selected",
            apply: "Apply filters",
            reset: "Reset",
        },
        minigame: {
            loading: "Loading...",
            score: "Your score:",
            wins: "wins",
            submitted: "This score has already been submitted",
            sendError: "Submission error",
            banned: "You can no longer submit scores",
            namePlaceholder: "Enter your name",
            submit: "Submit",
        },
        profile: {
            home: "Home",
            mainAchievement: "Main achievement",
            place: "Place of achievement:",
            about: "About",
            related: "From the same category",
            otherWomen: "Other remarkable women",
            recognize: "Do you recognize her?",
            loading: "Loading...",
            noRelated: "No other profiles are available in this category.",
            noRandom: "No profiles are available at the moment.",
            notFound: "Profile not found",
            backHome: "← Back to homepage",
            notFoundSeoTitle: "Profile not found",
            notFoundSeoDescription:
                "The requested profile was not found in the Femei de succes din Republica Moldova database. Return to the homepage to view other profiles.",
        },
        contact: {
            title: "Contact us",
            intro: "Have a question, suggestion, or request to edit or remove a profile? Write to us using the form below or directly by email.",
            infoTitle: "Contact information",
            phone: "Phone",
            email: "Email",
            country: "Country",
            countryValue: "Republic of Moldova",
            note: "We usually reply within 1-3 business days. For personal data requests or profile removal, please also see the",
            formTitle: "Contact form",
            name: "Name",
            namePlaceholder: "Your name",
            subject: "Subject",
            subjectPlaceholder: "E.g. profile removal request",
            message: "Message",
            messagePlaceholder: "Write your message here...",
            requiredError: "Please complete all required fields.",
            sendError: "Submission error. Please try again.",
            sending: "Sending...",
            submit: "Send message",
        },
        about: {
            title: "About",
            sections: [
                {
                    title: "Our mission",
                    paragraphs: [
                        "Femei de succes din Republica Moldova is a platform dedicated to recognizing and promoting remarkable women connected to Moldova.",
                        "We believe these stories deserve to be known, celebrated, and passed on to future generations.",
                    ],
                },
                {
                    title: "What we offer",
                    paragraphs: [
                        "Our database includes profiles of women from Moldova who have stood out locally and internationally.",
                        "The platform also includes an interactive recognition game where users can test how well they know successful women of Moldova.",
                    ],
                    list: [
                        "Biographical information and field of activity",
                        "Achievements and contributions",
                        "Main place of activity",
                        "Profile photo",
                    ],
                },
                {
                    title: "Our data",
                    paragraphs: [
                        "All information published on this platform is collected from public online sources and presented to promote Moldovan women personalities.",
                        "If you want to request an edit or removal of a profile, contact us through the contact page.",
                    ],
                },
            ],
        },
        legal: {
            privacyTitle: "Privacy Policy",
            privacyUpdated: "Last updated: June 25, 2026",
            termsTitle: "Terms and Conditions",
            termsUpdated: "Effective date: June 25, 2026",
            privacySections: [
                {
                    title: "1. Introduction",
                    paragraphs: [
                        "This Privacy Policy explains what data the Femei de succes din Republica Moldova website collects, how that data is used, and what rights users have regarding personal data.",
                    ],
                },
                {
                    title: "2. Data we collect directly",
                    paragraphs: [
                        "We directly collect data submitted through the contact form: name, email, subject, message, and the IP address associated with the submission.",
                        "We store cookie preference, minigame score, and game restriction status in localStorage.",
                        "We do not directly collect session duration or full browsing history. Published profiles are built from publicly available information.",
                    ],
                },
                {
                    title: "3. How we use data",
                    list: [
                        "to operate and secure the website;",
                        "to respond to user messages;",
                        "to remember cookie preferences;",
                        "to run the minigame;",
                        "to display ads through Google AdSense.",
                    ],
                },
                {
                    title: "4. Google AdSense and personalized ads",
                    paragraphs: [
                        "The website uses Google AdSense to display ads. Google and other third-party vendors may use cookies to serve ads based on previous visits to this or other websites.",
                        "Google AdSense may use cookies for personalized ads. More information is available at https://policies.google.com/technologies/ads.",
                    ],
                },
                {
                    title: "5. Google Analytics",
                    paragraphs: [
                        "The current website code does not configure a Google Analytics identifier. If Google Analytics is enabled later, this policy will be updated.",
                    ],
                },
                {
                    title: "6. User rights",
                    list: [
                        "right of access to personal data;",
                        "right to rectification;",
                        "right to deletion;",
                        "right to restriction of processing;",
                        "right to object;",
                        "right to withdraw consent.",
                    ],
                },
                {
                    title: "7. Contact details",
                    paragraphs: [
                        "For requests about personal data, cookies, or published profiles, contact us at ellemoldova1@gmail.com or +373 68 680 112.",
                    ],
                },
            ],
            termsSections: [
                {
                    title: "1. Acceptance of terms",
                    paragraphs: [
                        "By accessing and using the Femei de succes din Republica Moldova website, you accept these Terms and Conditions.",
                    ],
                },
                {
                    title: "2. Purpose and description of the website",
                    paragraphs: [
                        "The website is an informational platform dedicated to women connected to Moldova who have stood out in different fields.",
                        "The published information is collected, summarized, and organized from public sources.",
                    ],
                },
                {
                    title: "3. Use of content",
                    paragraphs: [
                        "We do not claim copyright over photos, quotes, texts, or other materials taken from public sources or belonging to their original owners.",
                        "Content published on the website may be shared or reused freely, while users remain responsible for respecting original rights holders.",
                    ],
                },
                {
                    title: "4. Responsibilities and limitations",
                    paragraphs: [
                        "We make efforts to publish accurate and useful information, but we do not guarantee that all data is complete, current, or error-free.",
                        "The website is provided for informational purposes.",
                    ],
                },
                {
                    title: "5. Editing or removing a profile",
                    paragraphs: [
                        "The person featured in a profile, their representative, or a rights holder may request editing, correction, or removal of a profile.",
                        "Requests can be sent through the contact page, to ellemoldova1@gmail.com, or by phone at +373 68 680 112.",
                    ],
                },
                {
                    title: "6. Applicable law",
                    paragraphs: ["These Terms and Conditions are governed by the laws of the Republic of Moldova."],
                },
            ],
        },
        cookie: {
            title: "Cookie Policy",
            text: "This website uses cookies and similar technologies to remember your preference and display Google AdSense ads, including personalized ads where permitted.",
            privacy: "Privacy Policy",
            reject: "Reject",
            accept: "Accept",
        },
        seo: {
            defaultDescription:
                "Discover remarkable women from the Republic of Moldova, their profiles, achievements, and success stories in culture, sport, science, business, and art.",
            defaultTitle: "Femei de succes din Republica Moldova — remarkable stories that inspire",
            profileFallbackTitle: "Successful woman profile",
            profileFallbackDescription:
                "Discover the profile of a remarkable woman from the Republic of Moldova, with achievements, field of activity, photo, and story from public sources.",
            publicInfo: "Profile built from publicly available information.",
            womanIncluded: "{{name}} is included in the Femei de succes din Republica Moldova project",
            discoverStory: "Discover her success story on {{siteName}}.",
        },
    },
};

// Objects are merged key by key; arrays (e.g. the "Despre noi" sections) are replaced as a whole.
function mergeCopy(target, source) {
    Object.entries(source || {}).forEach(([key, value]) => {
        if (value && typeof value === "object" && !Array.isArray(value) && target[key] && typeof target[key] === "object") {
            mergeCopy(target[key], value);
        } else {
            target[key] = value;
        }
    });

    return target;
}

Object.keys(translations).forEach((language) => {
    mergeCopy(translations[language], SITE_COPY[language]);
});
